import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { KeyRound } from 'lucide-react';
import api from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { DirectorIdForm } from '../components/bulk/DirectorIdForm';

const Shell = ({ children }) => (
  <div className="min-h-screen bg-background flex items-start justify-center px-4 py-12" data-testid="did-public-page">
    <div className="w-full max-w-lg rounded-xl border border-border bg-card p-6 sm:p-8 shadow-sm space-y-6">
      <div className="flex items-center gap-2"><KeyRound className="w-5 h-5 text-primary" /><h1 className="font-headings text-xl font-bold">Director Identification Number</h1></div>
      {children}
    </div>
  </div>
);

export default function DirectorIdPublic() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [gone, setGone] = useState('');
  const [sent, setSent] = useState(false);
  const [code, setCode] = useState('');
  const [sess, setSess] = useState(null);
  const [view, setView] = useState(null);
  const [err, setErr] = useState('');
  useEffect(() => { api.get(`/api/public/did/${token}`).then((r) => setInfo(r.data)).catch((e) => setGone(e.response?.data?.detail || 'This link is no longer active.')); }, [token]);
  const hdr = (s) => ({ headers: { 'X-DID-Session': s } });
  const sendCode = async () => {
    setErr('');
    try { await api.post(`/api/public/did/${token}/code`); setSent(true); } catch (e) { setErr(e.response?.data?.detail || 'Could not send a code'); }
  };
  const verify = async () => {
    setErr('');
    try {
      const r = await api.post(`/api/public/did/${token}/verify`, { code });
      setSess(r.data.session);
      setView((await api.get('/api/public/did-session', hdr(r.data.session))).data);
    } catch (e) { setErr(e.response?.data?.detail || 'That code did not work'); }
  };
  if (gone) return <Shell><p className="text-sm" data-testid="did-link-expired">{gone}</p></Shell>;
  if (!info) return <Shell><p className="text-sm text-muted-foreground">Loading…</p></Shell>;
  if (view) return <Shell><DirectorIdForm view={view} onSubmit={async (b) => (await api.post('/api/public/did-session/submit', b, hdr(sess))).data} /></Shell>;
  return (
    <Shell>
      <p className="text-sm">To keep your details safe we'll email a 6-digit code to <span className="font-medium" data-testid="did-email-hint">{info.email_hint}</span>.</p>
      {!sent ? <Button onClick={sendCode} data-testid="did-send-code-btn">Email me a code</Button> : (
        <div className="flex gap-2">
          <Input inputMode="numeric" maxLength={6} placeholder="6-digit code" value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))} className="max-w-[10rem] font-mono tracking-widest" data-testid="did-code-input" />
          <Button onClick={verify} disabled={code.length !== 6} data-testid="did-verify-btn">Continue</Button>
          <Button variant="ghost" onClick={sendCode} data-testid="did-resend-code-btn">Resend</Button>
        </div>
      )}
      {err && <p className="text-sm text-destructive" role="alert" data-testid="did-otp-error">{err}</p>}
    </Shell>
  );
}
